import { render, staticRenderFns } from "./StructureModal.vue?vue&type=template&id=dc4cfda4&scoped=true&"
import script from "./StructureModal.vue?vue&type=script&lang=js&"
export * from "./StructureModal.vue?vue&type=script&lang=js&"
import style0 from "./StructureModal.vue?vue&type=style&index=0&id=dc4cfda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4cfda4",
  null
  
)

export default component.exports